import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'
import { ButtonsContainer, CancelButtonOverrides, ConfirmButtonOverrides } from './styled-components'

const ModalButtons = ({ onCancel, onConfirm, disabled, hidden }) => {
  const { t } = useTranslation()
  if (hidden) {
    return null
  }
  return (
    <ButtonsContainer>
      <SDButton onClick={onCancel} overrides={CancelButtonOverrides}>{t('subscriptionForm:contract_modal.cancel_button')}</SDButton>
      <SDButton disabled={disabled} onClick={onConfirm} overrides={ConfirmButtonOverrides}>
        {t('subscriptionForm:contract_modal.confirm_button')}
      </SDButton>
    </ButtonsContainer>
  )
}

ModalButtons.propTypes = {
  hidden: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
}

export default ModalButtons
